import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { green } from "../constants/colors";
import CustomSelector from "./customSelector";
import { CustomInput } from "./customInput";
import axios from "axios";
import { baseUrl } from "../utills";
import CustomDropdown from "./customDropDown";
import { CiMenuKebab } from "react-icons/ci";
import DefaultDropDown from "./defaultDropDown";

const { Search } = Input;

// Custom styled Search component
const StyledSearch = styled(Input)`
  width: 370px;
  margin-right: 30px;
  .ant-input {
    border-radius: 6px;
    font-size: 16px;
    padding: 11px;
    background: #13141a;
    color: white;
    border: none;
    &::placeholder {
      color: #888;
      opacity: 1;
    }
  }

  .ant-input-search-button {
    width: 50px;
    height: 45.6px;
    background-color: ${green};
    border-radius: 8px;
    font-weight: bold;
    &:hover {
      background-color: ${green} !important;
    }
  }
`;

const MainSearch = () => {
  const token = localStorage.getItem("access_token");
  const [cities, setCities] = useState([]);

  const fetchCities = async () => {
    try {
      const res = await axios.get(baseUrl + "cities/", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (res.status === 200) {
        setCities(
          res?.data?.map((item) => {
            return {
              label: item?.name,
              value: item?.id,
            };
          })
        );
      }
      console.log("citiess in search", res);
    } catch (error) {
      console.error("error:", error);
    }
  };
  useEffect(() => {
    fetchCities();
  }, []);
  console.log("cities.....", cities);

  return (
    <div className="w-[600px] flex">
      {/* <StyledSearch
        placeholder="Car Make or Model"
        enterButton={<SearchOutlined style={{ fontSize: "22px" }} />}
        size="large"
        loading
      /> */}
      <div className="w-[200px]">
        <CustomInput placeholder="Car Make or Model" mainSearch="true" />
      </div>
      <div className="w-[200px]">
        <CustomSelector options={cities} mainSearch="true" />
      </div>
      <div className="w-[200px]">
        <DefaultDropDown />
      </div>
    </div>
  );
};

export default MainSearch;
